import { render, staticRenderFns } from "./shipShore.vue?vue&type=template&id=d4e665b0&scoped=true"
import script from "./shipShore.vue?vue&type=script&lang=js"
export * from "./shipShore.vue?vue&type=script&lang=js"
import style0 from "./shipShore.vue?vue&type=style&index=0&id=d4e665b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e665b0",
  null
  
)

export default component.exports